/**
 * Shared validation utilities
 */

/**
 * Email validation regex pattern
 * Matches standard email format: local@domain.tld
 */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates an email address format
 * @param email - Email address to validate
 * @returns true if email format is valid, false otherwise
 */
export function isValidEmail(email: string): boolean {
  if (!email || typeof email !== 'string') {
    return false;
  }
  return EMAIL_REGEX.test(email.trim());
}

/**
 * Normalizes an email address (lowercase + trim)
 * @param email - Email address to normalize
 * @returns Normalized email address
 */
export function normalizeEmail(email: string): string {
  if (!email || typeof email !== 'string') {
    return '';
  }
  return email.toLowerCase().trim();
}

/**
 * Validates and normalizes an email address
 * @param email - Email address to validate and normalize
 * @returns Normalized email if valid, empty string otherwise
 */
export function validateAndNormalizeEmail(email: string): string {
  const normalized = normalizeEmail(email);
  return isValidEmail(normalized) ? normalized : '';
}
